import { Component, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ClubServicesService } from '../../services/club-services.service';
import { ToastrService } from 'ngx-toastr';
import { StripeService, StripeCardComponent } from "ngx-stripe";
import { switchMap } from "rxjs/operators";
import {
  StripeCardElementOptions,
  StripeElementsOptions
} from '@stripe/stripe-js';
import { CommonService } from '../../services/common.service';


@Component({
  selector: 'app-addcard-details',
  templateUrl: './addcard-details.component.html',
  styleUrls: ['./addcard-details.component.scss']
})
export class AddcardDetailsComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<AddcardDetailsComponent>,
    private fb: FormBuilder,
    private router: Router,
    private clubService: ClubServicesService,
    private toastService: ToastrService,
    private stripeService: StripeService,
    private commonService: CommonService
  ) { }

  @ViewChild(StripeCardComponent) card: StripeCardComponent;
  stripeTest: FormGroup;
  paying = false;

  Stripe:any;

  cardform = this.fb.group({
    name: new FormControl('', [Validators.required]),
    number: new FormControl('', [Validators.required]),
    date: new FormControl('', [Validators.required]),
    year: new FormControl('', [Validators.required]),
    cvvno: new FormControl('', [Validators.required]),
  })

  async  ngOnInit() {

    this.stripeTest = this.fb.group({
      name: ["", [Validators.required]],
    });
  }


  cardOptions: StripeCardElementOptions = {
    hidePostalCode: true,
    style: {
      base: {
        color: 'black',
        // fontWeight: 400,
        // fontFamily: 'Sora',
        fontSize: '15px',
        // ':-webkit-autofill': {color: 'black'}
      }
    }
  }

  async onSubmit() {
    const stripe = await this.clubService.getStripeInstance();

    // Handle payment processing using Stripe's API
  }
  

  CloseModal() {
    this.dialogRef.close();
  }

  async savecard() {
    const name = this.stripeTest.get('name').value;
    this.stripeService
      .createToken(this.card.element, { name })
      .subscribe((result) => {
        if (result.token) {
          // Use the token
          console.log(result.token.id);
          this.clubService.addCard({token:result.token.id}).subscribe((res:any)=>{
            if(res.status == 200){
              this.toastService.success("card added successfully");
              this.commonService.getAllUsersCardsList(true);
              // location.reload();    
              // let currentURL = this.router.url
              // this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
              //   this.router.navigate([currentURL]);
              // });
            }
          },(err)=>{
            this.toastService.error(err.error.error.message);
          })
        } else if (result.error) {
          this.toastService.error(result.error.message)
        }
      });
  }

  numberOnly(evt: any) {
    console.log(1);
    console.log(2);
    console.log(3);
    let value = evt.target.value;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode == 46) {
      return false;
    }
    if (charCode == 8 || charCode == 37) {
      return true;
    } else if (charCode == 46 && value.indexOf(".") != -1) {
      return false;
    } else if (
      charCode > 31 &&
      charCode != 46 &&
      (charCode < 48 || charCode > 57)
    ) {
      return false;
    }
    return true;
  }
}
